import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

interface ConfirmBankDocumentModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  bankProofFile: File | null;
  bankProofPreview: string | null;
}

const ConfirmBankDocumentModal: React.FC<
  ConfirmBankDocumentModalProps
> = ({
  show,
  onClose,
  onConfirm,
  isSubmitting,
  bankProofFile,
  bankProofPreview,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">
          Review & Confirm Bank Document
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Quick Checks FIRST */}
        <div
          className="border rounded-3 p-3 mb-3"
          style={{ backgroundColor: '#FFF8E1' }}
        >
          <h6 className="fw-semibold mb-2">Before Submitting</h6>
          <ul className="mb-0 ps-3 small">
            <li>
              Ensure your <strong>full name</strong> is clearly visible
            </li>
            <li>
              Ensure the <strong>account number</strong> is readable
            </li>
            <li>
              The document should not be <strong>blurred</strong> or
              <strong> cropped</strong>
            </li>
            <li>
              Upload only documents from your own
              <strong> active savings bank account</strong>
            </li>
          </ul>
        </div>

        {/* Common Mistakes */}
        <div className="border rounded-3 p-3 mb-4">
          <h6 className="fw-semibold mb-2 text-danger">
            Common mistakes customers make
          </h6>
          <ul className="mb-0 ps-3 small text-muted">
            <li>
              Uploading <strong>Aadhaar</strong> or <strong>PAN card</strong>
            </li>
            <li>
              Uploading <strong>someone else’s bank document</strong>
            </li>
            <li>
              Uploading a <strong>cropped</strong> image
            </li>
            <li>
              Uploading an <strong>unclear / low-quality</strong> image
            </li>
          </ul>
        </div>

        {/* Small Preview Frame */}
        <div className="border rounded-3 p-3 bg-light">
          <h6 className="fw-semibold mb-3 text-muted">
            Uploaded Document Preview
          </h6>

          {bankProofFile && (
            <div className="small text-muted mb-1">
              File Name
            </div>
          )}

          {bankProofFile && (
            <div className="fw-semibold small mb-3">
              {bankProofFile.name}
            </div>
          )}

          <div
            className="border rounded-2 bg-white d-flex align-items-center justify-content-center"
            style={{
              height: 160,
              overflow: 'hidden',
            }}
          >
            {bankProofPreview ? (
              <img
                src={bankProofPreview}
                alt="Bank Proof Preview"
                style={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <div className="text-muted small">
                No preview available.
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={onClose}
          disabled={isSubmitting}
        >
          Edit Document
        </Button>

        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="me-2" />
              Verifying...
            </>
          ) : (
            'Confirm & Submit'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmBankDocumentModal;
